// 영수증 QR에서 배송묶음 id를 뽑아낸다.
//
// QR에는 https://delivery.cookerp.shop/d/<uuid> 형태가 들어가지만,
// 과거에 발행된 영수증이나 손으로 만든 링크는 /delivery?delivery_id=<uuid>
// 형태일 수 있어 둘 다 받아준다. 도메인이 바뀌어도(운영/스테이징) 동작하도록
// 호스트는 검사하지 않고 경로 모양만 본다.

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * @param {string} raw - QR에서 읽은 문자열
 * @returns {string|null} 배송묶음 UUID, 알아볼 수 없으면 null
 */
export function extractDeliveryId(raw) {
  if (!raw || typeof raw !== 'string') {
    return null;
  }

  const text = raw.trim();

  // UUID만 담긴 QR도 허용
  if (UUID_RE.test(text)) {
    return text;
  }

  let url;
  try {
    // 상대 경로만 들어와도 파싱되도록 base를 준다
    url = new URL(text, window.location.origin);
  } catch {
    return null;
  }

  // /delivery?delivery_id=<uuid>
  const fromQuery = url.searchParams.get('delivery_id');
  if (fromQuery && UUID_RE.test(fromQuery.trim())) {
    return fromQuery.trim();
  }

  // /d/<uuid>
  const match = url.pathname.match(/\/d\/([^/]+)\/?$/);
  if (match && UUID_RE.test(match[1])) {
    return match[1];
  }

  return null;
}
